import { Disposable } from 'record-it-utils/utils/DisposableContainer/DisposableContainer';
import { EntityManagerEntityTypesByEntityName } from '../EntityManagerEntityTypesByEntityName';
import { AnySynchronizationEnvironmentTypesConstraint } from '../SynchronizationEnvironmentTypes';
import { EntityFilter, EntityNameToIsVisibleFunction } from './EntityFilter';

export class ShowAllEntityFilter<
  TSynchronizationEnvironmentTypes extends
    AnySynchronizationEnvironmentTypesConstraint,
  TEntityTypesByEntityName extends
    EntityManagerEntityTypesByEntityName<TSynchronizationEnvironmentTypes>
> implements
    EntityFilter<TSynchronizationEnvironmentTypes, TEntityTypesByEntityName>
{
  public readonly entityNameToIsVisibleFunction: EntityNameToIsVisibleFunction<
    TSynchronizationEnvironmentTypes,
    TEntityTypesByEntityName
  > = {};

  public subscribe(): Disposable {
    return {
      dispose: () => {}
    };
  }
}
